import { render, staticRenderFns } from "./PayerListDetails.vue?vue&type=template&id=55bfb844"
import script from "./PayerListDetails.vue?vue&type=script&lang=js"
export * from "./PayerListDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports